<template>
    <div>
        <Row :gutter="16">
            <Card>
                <p slot="title">{{t.routerName}}</p>
                <Row>
                    <Col>
                        <Form :model="formItem" :rules="ruleValidate" :label-width="120" label-position="right"
                              ref="form">
                            <Row>
                                <Col>
                                    <FormItem :label="t.ad.adSpace" prop="adSpaceIndex">
                                        <Select v-model="formItem.adSpaceIndex" style="width:200px;"
                                                :placeholder="msgUtil.placeholderSelected(t.ad.adSpace)"
                                                @on-change="onSpaceChange">
                                            <Option v-for="adSpace in adSpaceList" :value="adSpace.id"
                                                    :key="adSpace.id">
                                                {{ adSpace.name }}
                                            </Option>
                                        </Select>
                                    </FormItem>
                                    <FormItem :label="t.ad.name" prop="name">
                                        <Input v-model="formItem.name" :maxlength="64"
                                               :placeholder="msgUtil.placeholderRequired(t.ad.name)"></Input>
                                    </FormItem>
                                    <FormItem :label="t.ad.image" prop="image">
                                        <Input v-model="formItem.image" readonly>
                                            <Button v-if="formItem.spaceId != null && formItem.spaceId !== ''"
                                                    slot="append" type="success"
                                                    @click="openImageModal">
                                                {{msgUtil.message.action.picSelect}}
                                            </Button>
                                            <Button v-else slot="append" type="success"
                                                    disabled>
                                                {{msgUtil.message.action.picSelect}}
                                            </Button>
                                        </Input>
                                    </FormItem>
                                    <FormItem :label="t.ad.link" prop="link">
                                        <Input v-model="formItem.link" :maxlength="100"
                                               :placeholder="msgUtil.placeholderRequired(t.ad.link)"></Input>
                                    </FormItem>
                                    <FormItem :label="t.ad.pattern" prop="pattern">
                                        <Select v-model="formItem.pattern"
                                                :placeholder="msgUtil.placeholderSelected(t.ad.pattern)"
                                                @on-change="patternChange">
                                            <Option value="0">{{t.ad.pDay}}</Option>
                                            <Option value="1">{{t.ad.pHits}}</Option>
                                        </Select>
                                    </FormItem>
                                    <Form-item :label="t.ad.startTime" prop="startTime">
                                        <DatePicker type="datetime" format="yyyy/MM/dd HH:mm:ss"
                                                    v-model="formItem.startTime" style="width: 100% !important"
                                                    :placeholder="msgUtil.placeholderRequired(t.ad.startTime)"
                                                    :options="startTimeOption"
                                                    @on-change="onStartTimeChange"></DatePicker>
                                    </Form-item>
                                    <Form-item :label="t.ad.endTime" v-if="showPatternTime===true" prop="endTime">
                                        <DatePicker type="datetime" format="yyyy/MM/dd HH:mm:ss"
                                                    v-model="formItem.endTime" style="width: 100% !important"
                                                    :placeholder="msgUtil.placeholderRequired(t.ad.endTime)"
                                                    :options="endTimeOption"
                                                    @on-change="onEndTimeChange"></DatePicker>
                                    </Form-item>
                                    <FormItem :label="t.ad.pHits" prop="patternHits"
                                              v-if="showPatternHits===true">
                                        <InputNumber v-model="formItem.patternHits" :max="9999999999" :min="0"
                                                     :step="1000"></InputNumber>
                                    </FormItem>
                                    <FormItem :label="t.ad.sortOrder" prop="sortOrder">
                                        <InputNumber v-model="formItem.sortOrder" :max="9999" :min="0"></InputNumber>
                                    </FormItem>

                                    <FormItem :label="t.ad.status" prop="status">
                                        <i-switch v-model="formItem.status" size="large" true-value="1" false-value="0">
                                            <span slot="open">{{t.ad.open}}</span>
                                            <span slot="close">{{t.ad.close}}</span>
                                        </i-switch>
                                    </FormItem>
                                    <FormItem :label="t.ad.description" prop="description">
                                        <tinymce id="id1" v-model="formItem.description" :toolbar1="toolbar1"
                                                 :other_options="other_options"></tinymce>
                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col span="8">
                                    <FormItem>
                                        <Button type="primary" :loading="loading" @click="handleSubmit()">
                                            {{msgUtil.message.action.submit}}
                                        </Button>
                                        <Button @click="handleReset()" style="margin-left: 8px">
                                            {{msgUtil.message.action.reset}}
                                        </Button>
                                    </FormItem>
                                </Col>
                                <Col span="16">
                                <span style="float: right;">
                                    <div class="ad-upload-list" v-if="formItem.image != null && formItem.image !== ''">
                                        <img :src="formItem.image"/>
                                        <div class="ad-upload-list-cover">
                                            <Icon type="ios-eye-outline" @click="openPreviewImageModal"></Icon>
                                        </div>
                                    </div>
                                    <div class="img-drag" v-else>
                                        <div style="width: 58px;height:58px;line-height: 58px;">
                                            <Icon type="ios-camera" size="20"></Icon>
                                        </div>
                                    </div>
                                </span>
                                    <Modal v-model="previewImageModal" :width="previewImageModalWidth">
                                        <img :src="previewImage" style="max-width:100%;max-height:100%;">
                                        <div slot="footer">
                                            {{formItem.adSpaceName}}
                                        </div>
                                    </Modal>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            </Card>
        </Row>
        <Modal
            :title='msgUtil.message.action.changePic'
            v-model="imageModal"
            :mask="true"
            :footer-hide="true"
            :mask-closable="false"
            :width="imageModalWidth">
            <Row>
                <div class="sub-cropper">
                    <vueCropper
                        ref="cropper"
                        :img="option.img"
                        :outputSize="option.outputSize"
                        :outputType="option.outputType"
                        :info="option.info"
                        :full="option.full"
                        :canMove="option.canMove"
                        :canMoveBox="option.canMoveBox"
                        :fixedBox="option.fixedBox"
                        :original="option.original"
                        :autoCrop="option.autoCrop"
                        :autoCropWidth="option.autoCropWidth"
                        :autoCropHeight="option.autoCropHeight"
                        :centerBox="option.centerBox"
                        :high="option.high"
                        :infoTrue="option.infoTrue"
                        @realTime="realTime"
                        @imgLoad="imgLoad"
                        @cropMoving="cropMoving"
                        :enlarge="option.enlarge"
                    ></vueCropper>
                </div>
            </Row>
            <Row>
                <Col style="text-align:right;">
                    <Upload action="image/jpeg" :before-upload="handleBeforeUpload"
                            style="display:inline-block;margin-right: 10px;">
                        <Button icon="ios-cloud-upload-outline">
                            {{msgUtil.message.action.picSelect}}
                        </Button>
                    </Upload>
                    <Button v-if="option.img != null && option.img !== ''" type="primary" @click="handleUpload">
                        {{msgUtil.message.action.upload}}
                    </Button>
                    <Button v-else type="primary" disabled>
                        {{msgUtil.message.action.upload}}
                    </Button>
                </Col>
            </Row>
        </Modal>
    </div>
</template>
<script>
import BaseUrl from '_conf/url';
import axios from 'axios';
import { edit, getAdInfo, getAdSpaceList } from '@/api/ad';
import { VueCropper } from 'vue-cropper';
import { uploadImg } from '@/api/image';

export default {
    name: 'content_ad_edit',
    components: {
        VueCropper,
    },
    data() {
        const t = this.$_t();
        const msgUtil = this.$msgUtil;
        return {
            self: this,
            t: t,
            msgUtil: msgUtil,
            option: {
                img: '',
                outputSize: 1,
                //输出图片格式
                outputType: 'png',
                info: true,
                //截图信息展示是否是真实的输出宽高
                infoTrue: true,
                //是否输出原图比例的截图
                full: false,
                //能否拖动图片
                canMove: true,
                //能否拖动截图框
                canMoveBox: true,
                //截图框固定大小
                fixedBox: true,
                //上传图片是否显示原始宽高 (针对大图 可以铺满)
                original: false,
                //是否自动生成截图框
                autoCrop: true,
                // 只有自动截图开启 宽度高度才生效
                autoCropWidth: 0,
                autoCropHeight: 0,
                //截图框是否限制在图片里(只有在自动生成截图框时才能生效)
                centerBox: false,
                //是否根据dpr生成适合屏幕的高清图片
                high: true,
                //是否按照截图框比例输出 默认为1
                enlarge: 1,
                cropData: {},
            },
            imageModal: false,
            previewImageModal: false,
            previewImage: null,
            formItemBk: {},
            formItem: {
                name: '',
                link: '',
                type: '0',
                pattern: '0',
                startTime: '',
                endTime: '',
                patternHits: 0,
                sortOrder: 0,
                status: '1',
                description: '',
                image: null,
                spaceId: null,
                adSpaceIndex: 0,
                adSpaceName: null,
            },
            startTimeOption: {},
            endTimeOption: {},
            showPatternTime: true,
            showPatternHits: false,
            adSpaceList: [],
            ruleValidate: {
                adSpaceIndex: [
                    {
                        required: true,
                        message: msgUtil.errorSelected(t.ad.adSpace),
                        trigger: 'blur',
                    },
                ],
                name: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.ad.name),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 64,
                        message: msgUtil.errorMaxLengthFullWidth(t.ad.name, 64),
                        trigger: 'blur',
                    },
                ],
                image: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.ad.image),
                        trigger: 'blur',
                    },
                ],
                link: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.ad.link),
                        trigger: 'blur',
                    },
                    {
                        type: 'string',
                        max: 100,
                        message: msgUtil.errorMaxLengthFullWidth(t.ad.link, 100),
                        trigger: 'blur',
                    },
                ],
                startTime: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.ad.startTime),
                        trigger: 'blur',
                    },
                ],
                endTime: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.ad.endTime),
                        trigger: 'blur',
                    },
                ],
                patternHits: [
                    {
                        required: true,
                        message: msgUtil.errorRequired(t.ad.pHits),
                        type: 'number',
                        trigger: 'blur',
                    },
                ],
                description: [
                    {
                        type: 'string',
                        max: 30000,
                        message: msgUtil.errorMaxLengthFullWidth(t.ad.description, 30000),
                        trigger: 'blur',
                    },
                ],
            },
            loading: false,
            toolbar1:
                'newnote print preview code | undo redo | insert | styleselect | fontsizeselect | fontselect | forecolor backcolor bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image emoticons media codesample',
            other_options: {
                height: 400,
                menubar: false,
                plugins: 'image code print preview',
                images_upload_handler: function(blobInfo, success, failure) {
                    let param = new FormData(); //创建form对象
                    param.append('image', blobInfo.blob(), blobInfo.filename()); //通过append向form对象添加数据
                    axios
                        .post(BaseUrl.dataUrl + '/image/scale/', param)
                        .then(response => success(BaseUrl.Url + response.data.url));
                },
            },
        };
    },
    beforeCreate() {
        import('tinymce-i18n/langs/ja');
    },
    computed: {
        imageModalWidth() {
            let width = this.option.autoCropWidth + 100;
            return width < 600 ? 600 : width;
        },
        previewImageModalWidth() {
            let width = this.option.autoCropWidth + 32;
            return width < 100 ? 105 : width;
        },
    },
    methods: {
        async handleSubmit() {
            this.loading = true;
            this.$Loading.start();
            if (this.formItem.startTime instanceof Date) {
                this.formItem.startTime = this.formItem.startTime.format('yyyy/MM/dd HH:mm:ss');
            }
            if (this.formItem.endTime instanceof Date) {
                this.formItem.endTime = this.formItem.endTime.format('yyyy/MM/dd HH:mm:ss');
            }
            if (await this.$refs['form'].validate()) {
                let adDto = {};
                adDto.spaceId = this.formItem.spaceId;
                adDto.name = this.formItem.name;
                adDto.image = this.formItem.image;
                adDto.link = this.formItem.link;
                adDto.type = this.formItem.type;
                adDto.pattern = this.formItem.pattern;
                adDto.startTime = this.formItem.startTime;
                adDto.endTime = this.formItem.endTime;
                adDto.patternHits = this.formItem.patternHits;
                adDto.sortOrder = this.formItem.sortOrder;
                adDto.status = this.formItem.status;
                adDto.description = this.formItem.description;
                await edit(this.$route.params.id, adDto);
                Object.assign(this.formItemBk, this.formItem);
                this.$Loading.finish();
                this.$Message.success(this.msgUtil.message.action.updateSuccess);
            } else {
                this.$Loading.error();
                this.$Message.error(this.msgUtil.message.action.updateFail);
            }
            this.loading = false;
        },
        handleReset() {
            this.$refs.form.resetFields();
            Object.assign(this.formItem, this.formItemBk);
            this.patternSwitch();
            this.loading = false;
        },
        resetShow() {
            this.showPatternTime = true;
            this.showPatternHits = false;
            this.startTimeOption = {};
            this.endTimeOption = {};
        },
        patternChange(event) {
            if (event === '0') {
                this.showPatternTime = true;
                this.showPatternHits = false;
            } else {
                this.showPatternTime = false;
                this.showPatternHits = true;
            }
            this.formItem.endTime = '';
            this.formItem.patternHits = 0;
        },
        patternSwitch() {
            //通过投放模式来初始化编辑初始界面
            if (this.formItem.pattern === '0') {
                //patternTime时间区间模式投放
                this.showPatternTime = true;
                this.showPatternHits = false;
            } else {
                //patternTime浏览量模式投放
                this.showPatternTime = false;
                this.showPatternHits = true;
                this.formItem.patternHits = parseInt(this.formItem.patternHits);
            }
        },
        onSpaceChange(id) {
            //console.log(id);
            this.formItem.spaceId = null;
            this.formItem.image = null;
            this.option.img = null;
            this.$refs.cropper.clearCrop();
            if (id != null) {
                const adSpace = this.adSpaceList[id - 1];
                this.formItem.spaceId = adSpace.id;
                this.formItem.adSpaceName = adSpace.name;
                this.option.autoCropWidth = parseInt(adSpace.width);
                this.option.autoCropHeight = parseInt(adSpace.height);
                this.$refs.cropper.changeCrop(this.option.autoCropWidth, this.option.autoCropHeight);
            }
        },
        /**
         * 开始时间发生变化时触发,设置结束时间不可选择的日期
         * 结束时间应大于等于开始时间,且小于等于当前时间
         * @param {string} startTime 格式化后的日期
         * @param {string} type 当前的日期类型
         */
        onStartTimeChange(startTime) {
            this.formItem.startTime = startTime;
            this.endTimeOption = {
                disabledDate(endTime) {
                    return endTime < new Date(startTime);
                },
            };
        },
        /**
         * 结束时间发生变化时触发,设置开始时间不可选择的日期
         * 开始时间小于等于结束时间,且小于等于当前时间
         * @param {string} date 格式化后的日期
         * @param {string} type 当前的日期类型
         */
        onEndTimeChange(endTime) {
            this.formItem.endTime = endTime;
            this.startTimeOption = {
                disabledDate(startTime) {
                    return startTime > new Date(endTime);
                },
            };
        },
        //图片预览
        openPreviewImageModal() {
            this.previewImage = this.formItem.image;
            this.previewImageModal = true;
        },
        //图片裁剪
        openImageModal() {
            this.option.img = this.formItem.image;
            this.$refs.cropper.changeCrop(this.option.autoCropWidth, this.option.autoCropHeight);
            this.imageModal = true;
        },

        handleBeforeUpload(file) {
            //上传图片
            if (!/^image/.test(file.type) || !/(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(file.name)) {
                this.$Notice.warning({
                    title: this.msgUtil.message.file.error.format,
                    desc:
                        this.msgUtil.message.file.name +
                        '{' +
                        file.name +
                        '}' +
                        this.msgUtil.message.file.error.typeFormat,
                    duration: 15,
                });
                return false;
            }

            const reader = new FileReader();
            reader.onload = e => {
                let data;
                if (typeof e.target.result === 'object') {
                    // 把Array Buffer转化为blob 如果是base64不需要
                    data = window.URL.createObjectURL(new Blob([e.target.result]));
                } else {
                    data = e.target.result;
                }
                this.option.img = data;
            };

            // 转化为base64
            // reader.readAsDataURL(file)
            // 转化为blob
            reader.readAsArrayBuffer(file);
            return false;
        },
        // 实时预览函数
        realTime(data) {
            //console.log(data);
        },
        handleUpload() {
            this.$refs.cropper.getCropBlob(data => {
                //var blobObject = new Blob([data]);
                const formData = new FormData();
                formData.append('image', data);
                uploadImg(formData).then(d => {
                    this.formItem.image = BaseUrl.Url + d.url;
                    this.imageModal = false;
                });
            });
        },
        imgLoad(msg) {
            //console.log(msg);
        },
        cropMoving(data) {
            this.option.cropData = data;
        },
    },
    async mounted() {
        //得到广告的信息
        const adInfo = await getAdInfo(this.$route.params.id);
        if (adInfo.ad != null) {
            this.formItem = adInfo.ad;

            this.patternSwitch();
            //得到广告位
            const adSpaces = await getAdSpaceList();
            if (adSpaces.adSpaceList != null) {
                this.adSpaceList = adSpaces.adSpaceList;
                if (this.formItem.spaceId != null) {
                    const adSpace = this.adSpaceList[this.formItem.spaceId - 1];
                    this.formItem.adSpaceIndex = this.formItem.spaceId;
                    this.formItem.adSpaceName = adSpace.name;
                    this.option.autoCropWidth = parseInt(adSpace.width);
                    this.option.autoCropHeight = parseInt(adSpace.height);
                }
            }
        }
        Object.assign(this.formItemBk, this.formItem);
    },
};
</script>
<style lang="less" scoped>
.img-drag {
    background: #fff;
    border: 1px dashed #dcdee2;
    border-radius: 4px;
    text-align: center;
    /*cursor: pointer;*/
    position: relative;
    overflow: hidden;
    transition: border-color 0.2s ease;
    display: inline-block;
    width: 58px;
    height: 58px;
    margin-left: 10px;
    &:hover {
        border: 1px dashed #2d8cf0;
    }
    img {
        width: 100%;
        vertical-align: middle;
    }
}

.sub-cropper {
    height: 600px;
    margin-bottom: 10px;
}

@keyframes slide {
    0% {
        background-position: 0 0;
    }
    100% {
        background-position: -100% 0;
    }
}

@media screen and (max-width: 1080px) {
    .sub-cropper {
        height: 600px;
    }
}

.ad-upload-list {
    display: inline-block;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    margin-right: 4px;
}

.ad-upload-list img {
    width: 100%;
    height: 100%;
}

.ad-upload-list-cover {
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
}

.ad-upload-list:hover .ad-upload-list-cover {
    display: block;
}

.ad-upload-list-cover i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
}
</style>
<style lang="less" src="@/assets/less/i-switch.less" scoped>
</style>
